import React from 'react'

import { BsSearch } from 'react-icons/bs'
import { Container, UpperContent, Content, SearchBar } from './styles'

import Checkbox from '../../../../components/Checkbox'
import Pagination from './Pagination'
import List from './List'
import { useGetMessages } from '../../hooks/use-get-messages'

const MessagesList: React.FC = () => {
  const { swr, pagination, params, isLoading } = useGetMessages()

  return (
    <Container>
      <Content>
        <UpperContent>
          <div className="search-options">
            <SearchBar>
              <BsSearch />

              <input
                type="text"
                placeholder="Buscar recados"
                onChange={(e) => params.setSearch(e.target.value)}
              />
            </SearchBar>
            <Checkbox onChange={params.setNotRead}>
              <span className="checkbox-label">Somente não lidos</span>
            </Checkbox>
          </div>

          <h1 className="title">Recados</h1>
        </UpperContent>

        <List data={swr.data.docs} isLoading={isLoading} error={swr.error} />

        {swr.data.docs.length !== 0 && <Pagination pagination={pagination} />}
      </Content>
    </Container>
  )
}

export default MessagesList
